<div class="accountSubscriptions_orders_row" *ngFor="let order of orders">
  <dl class="accountSubscriptions_orders_cell">
    <dt>{{"subscriptions.order"|translate}}</dt><dd>{{order.code}}</dd>
  </dl>
  <dl class="accountSubscriptions_orders_cell" [ngSwitch]="order.statusCode">
    <dt *ngSwitchCase="'CANCELLED'">{{"subscriptions.order.deliver.time2"|translate}}</dt>
    <dt *ngSwitchCase="'CANCELLING'">{{"subscriptions.order.deliver.time2"|translate}}</dt>
    <dt *ngSwitchDefault>{{"subscriptions.order.deliver.time"|translate}}</dt>
    <dd>{{order.time | date: 'dd.MM.yyyy'}}</dd>
  </dl>
  <dl class="accountSubscriptions_orders_cell" [ngSwitch]="order.statusCode">
    <dt>{{"subscriptions.order.status"|translate}}</dt>
    <dd>{{order.status}}</dd>
  </dl>
  <div class="accountSubscriptions_orders_cell">
    <a [href]="orderUrl+order.code">{{"subscriptions.order.details"|translate}}</a>
  </div>
  <div class="accountSubscriptions_orders_cell" *ngIf="order.paymentPaid !== undefined && recurring !== 'true'"></div>
</div>
<div *ngIf="hasMoreOrders" class="accountSubscriptions_orders_row">
  <v-spinner [activeSpinner]="processing"></v-spinner>
  <button (click)="getMoreOrders()" [disabled]="processing"  class="accountSubscriptions_moreOrders flaticon-down-arrow">{{"subscriptions.prevOrders"|translate}}</button>
</div>


